// World 10 (Obsidian) — the final world. "The wall. Everything learned."
// Pure d=9 pack — every level takes at least 9 moves to solve optimally,
// which is the practical ceiling the solver can reliably prove at our
// budget. This world only became shippable after the v0.4.4 heuristic
// upgrade: at the old ceil(N/5) bound, d=9 proofs routinely truncated;
// at the per-color-class bound, they complete in 60-180s.
//
// Progression: L1 opens at branching 15.78 (lowest available d=9 board —
// still hard, but readable). L10 climaxes at branching 28.50, the
// highest in the entire game across all 100 levels. Every level is
// r=3, tileCount=13 or 15, 5 or 6 colors. No radius-4 — the r=4 config
// produced 0 d=9 candidates at budget, suggesting that geometry's state
// space is too wide for the solver's current heuristic to prune deep.
// Generator: tools/generate-parallel.mjs --world 10. Seed 0xaebcb000.
// 20 candidates pooled in ~17194s (~4.8h walltime, 4-worker pool).
import type { LevelDef } from '@tessera/engine';
import { WORLD_10_GENERATED } from './world10-generated';

export const WORLD_10_LEVELS: LevelDef[] = [...WORLD_10_GENERATED];
